import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Parametro } from 'app/models/parametro.model';
import { ParametrosService } from 'app/services/parametros.service';
import { take } from 'rxjs';
import { FuseAlertType } from '@fuse/components/alert';
import { fuseAnimations } from '@fuse/animations';
@Component({
    selector: 'correos',
    templateUrl: './correos.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class CorreosComponent {
    alert: { type: FuseAlertType; message: string } = {
        type: 'success',
        message: '',
    };
    showAlert: boolean = false;
    opcionesCorreo: Parametro[] = [];
    infoCorreo: {
        id: string;
        subject: string;
        body: string;
        active: boolean;
    } = {
        id: null,
        subject: null,
        body: null,
        active: null,
    };
    guardandoCorreo: boolean = false;
    correoSelected: string = '';
    init: any = {
        //height: 400,
        base_url: '/tinymce',
        suffix: '.min',
        visual: false,
        branding: false,
        language: 'es',
        language_url: '/assets/tinymce/langs/es.js',
        plugins:
            'advlist autolink lists link image charmap preview anchor \
            searchreplace visualblocks fullscreen \
            insertdatetime media table code wordcount',
        toolbar:
            'undo redo | code | preview | formatselect | bold italic backcolor | \
            alignleft aligncenter alignright alignjustify | \
            bullist numlist outdent indent',
        image_advtab: true,
        mobile: {
            plugins: ['autosave', 'code', 'lists', 'autolink', 'preview'],
            toolbar: ['undo', 'code', 'preview', 'bold'],
        },
    };
    constructor(private _correos: ParametrosService, private route: Router) {
        this._correos
            .listarCorreosEventos()
            .pipe(take(1))
            .subscribe({
                next: (correos) => {
                    this.opcionesCorreo = correos;
                },
                error: (err) => {
                    console.log(err);
                    this.opcionesCorreo = [];
                },
                complete: () => {
                    let optDefaultCorreo: Parametro = {
                        ID: null,
                        TIPO: null,
                        NOMBRE: null,
                        VALOR: '',
                        ACTIVO: null,
                    };
                    this.opcionesCorreo.unshift(optDefaultCorreo);
                },
            });
    }

    goback(): void {
        this.route.navigateByUrl('home/sistema');
    }

    modalVariables = false;

    alertShow() {
        this.showAlert = true;
        setTimeout(() => {
            this.showAlert = false;
        }, 3000);
    }

    getCorreo() {
        if (!this.correoSelected) {
            this.infoCorreo = {
                id: null,
                subject: null,
                body: null,
                active: null,
            };
            return;
        }

        this._correos
            .getCorreo(this.correoSelected)
            .pipe(take(1))
            .subscribe({
                next: (correo) => {
                    this.infoCorreo = {
                        id: this.correoSelected,
                        subject: correo.SUBJECT,
                        body: correo.BODY,
                        active: correo.ACTIVE,
                    };
                    console.log(correo);
                },
                error: (err) => {
                    console.log(err);
                },
                complete: () => {},
            });
    }

    guardarCorreo() {
        if (!this.infoCorreo) {
            return;
        }

        this.guardandoCorreo = true;
        this._correos
            .postCorreo(this.infoCorreo)
            .pipe(take(1))
            .subscribe({
                next: () => {
                    this.guardandoCorreo = false;
                    this.alert = {
                        type: 'success',
                        message: 'Configuración guardada',
                    };
                    this.alertShow();
                    //console.log(correo);
                },
                error: (err) => {
                    console.log(err);
                    switch (err.status) {
                        default:
                            this.alert = {
                                type: 'error',
                                message: 'No se pudo completar la operación',
                            };
                            break;
                    }

                    this.alertShow();
                    this.guardandoCorreo = false;
                },
                complete: () => {},
            });
    }
}
